import React, {Component} from 'react';
import './request.scss'
export default class request extends Component {
  render() {    
    return (
      <div className="page-request">
        Hello request
      </div>
    )
  }
}